import React, { useState, useEffect } from "react";
import MyHeader from "./header";
import "./Signup.css";
import { useNavigate } from "react-router-dom";

const Signup = ({ cartItems = 0, cartList = [], cartTotal = 0, showCartDropdown = false, onCartToggle = () => {}, onRemoveItem = () => {} }) => {
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    password: "",
    email: "",
    address: "",
    tel1: "",
    tel2: "",
  });

  const [message, setMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    try { 
      const response = await fetch("/api/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/");
        }, 3000);
        setFormData({
          name: "",
          username: "",
          password: "",
          email: "",
          address: "",
          tel1: "",
          tel2: "",
        });
      } else {
        setMessage(data.message || "Registration failed");
      }
    } catch (error) {
      setMessage("Error connecting to server");
    }
  };

  return (
    <div style={{ paddingTop: "70px" }}>
      <MyHeader
        cartItems={cartItems}
        cartList={cartList}
        cartTotal={cartTotal}
        showCartDropdown={showCartDropdown}
        onCartToggle={onCartToggle}
        onRemoveItem={onRemoveItem}
      />
      <br/>      <br/>
      <br/>
      <br/>
      
       
       

      <div style={{ maxWidth: '600px', margin: '40px auto', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', borderRadius: '12px', backgroundColor: '#fff' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px', fontWeight: '700', fontSize: '2rem', color: '#333' }}>Sign Up</h2>
        {message && <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '10px 15px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center' }}>{message}</div>}
        {showToast && <div style={{ backgroundColor: '#d4edda', color: '#155724', padding: '10px 15px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center' }}>User registered successfully!</div>}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Name:
            <input 
              type="text" 
              name="name" 
              value={formData.name} 
              onChange={handleChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Username:
            <input 
              type="text" 
              name="username" 
              value={formData.username} 
              onChange={handleChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Password:
            <input 
              type="password" 
              name="password" 
              value={formData.password} 
              onChange={handleChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Email:
            <input 
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Address:
            <input 
              type="text" 
              name="address" 
              value={formData.address} 
              onChange={handleChange} 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Tel1:
            <input 
              type="tel" 
              name="tel1" 
              value={formData.tel1} 
              onChange={handleChange} 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Tel2:
            <input 
              type="tel" 
              name="tel2" 
              value={formData.tel2} 
              onChange={handleChange} 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <button 
            type="submit" 
            style={{ 
              padding: '12px', 
              borderRadius: '10px', 
              border: 'none', 
              backgroundColor: '#96085d', 
              color: 'white', 
              fontWeight: '700', 
              fontSize: '1.1rem', 
              cursor: 'pointer', 
              transition: 'background-color 0.3s ease' 
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#96085d'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#96085d'}
          >
            Sign Up
          </button>
        </form>
      

      <br/>
      <br/>
      <br/>
      <br/>
      </div>
    </div>
  );
};

export default Signup;
